"use client";
import DropdownOne from "@/components/search-dropdown/inner-dropdown/DropdownOne";

import {
  CartItem,
  addItem,
  removeItem,
  selectCartItems,
} from "../../../redux/features/cartSlice";

import Loader from "@/components/Loader/Loader";
import axiosInstance from "@/service/axiosInstance";

import { useParams, useRouter, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addScheduleFilter,
  scheduleFilterItems,
} from "@/redux/features/scheduleFilterSlice";
import {
  setCount,
  setEvents,
  setLoading,
  setPaginatedEvents,
} from "@/redux/features/eventSlice";
import { toast } from "react-toastify";
import EventCard from "./eventCard";
import { ACADEMICYEAR, emptyFilter, ToastOptions } from "@/utils/enum";
import Pagination from "@mui/material/Pagination";

const ScheduleListing = () => {
  const searchParams = useParams();
  const urlParams = useSearchParams();
  const filter = useSelector(scheduleFilterItems);

  if (
    searchParams?.slug &&
    Array.isArray(searchParams.slug) &&
    searchParams.slug.length > 1
  ) {
    searchParams.second = decodeURIComponent(searchParams.slug[1]);
  }
  const itemsPerPage = 8;

  const dispatch = useDispatch();
  const router = useRouter();
  const cart = useSelector(selectCartItems);
  const event = useSelector((state: any) => state.events.events);
  const count = useSelector((state: any) => state.events.count);
  const loading = useSelector((state: any) => state.events.eventLoading);

  const [cartData, setCartData] = useState(cart);
  const [currentPage, setcurrentPage] = useState(1);
  const startItem = Math.min(count, (currentPage - 1) * itemsPerPage + 1);
  const endItem = Math.min(count, currentPage * itemsPerPage);

  // const [data, setData] = useState<any>([]);
  // const [loading, setLoading] = useState(false);
  const [token, setToken] = useState<string | null>(null);
  const getData = async (currentPage: any, filters: any) => {
    try {
      dispatch(setLoading(true));
      console.log("calling api");
      const resp: any = await axiosInstance.post("/events", {
        sort: "createdAt:desc",
        page: filters.currentPage,
        limit: 8,
        eventsType: filters.eventsType,
        age: filters.age?.value,
        venue_address: filters.location?.value,
        school: filters.school?.value,
        category: filters.category,
        gender: filters.gender,
        eventsMode: filters.eventsMode,
        title: filters.title,
        registrationsOpen: filters.registrationsOpen,
        academicYear: ACADEMICYEAR,
      });
      console.log("🚀 ~ getData ~ resp:", resp);

      let updated = resp.events;

      // setCount(resp?.meta.pagination.total);
      updated = updated.map((item: any) => ({
        ...item,
        inCart: cart.filter((val) => val.id === item.id)[0]?.inCart || 0,
      }));

      dispatch(setLoading(false));
      dispatch(setEvents(updated));
      dispatch(setCount(resp?.meta.pagination.total));
      handlePageChange(filters.currentPage || currentPage, updated);
      // setData(updated);
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handlePageChange = (pageNumber: number, data?: any[]) => {
    setcurrentPage(pageNumber);

    const element = document.getElementById("cart-section");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }

    const startIndex = (pageNumber - 1) * itemsPerPage;
    dispatch(
      setPaginatedEvents(
        data
          ? data.slice(startIndex, startIndex + itemsPerPage)
          : event.slice(startIndex, startIndex + itemsPerPage),
      ),
    );
  };

  const onPageChange = async (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setcurrentPage(value);
    const newFilter = {
      ...filter,
      currentPage: value,
    };
    dispatch(addScheduleFilter(newFilter));
    await getData(value, newFilter);
    handlePageChange(value);
  };

  const getCart = (updated: any) => {
    for (let index in updated) {
      const cartCount = cart.filter((val) => val.id === updated[index].id);
      updated[index] = { ...updated[index], inCart: cartCount.length };
    }
    console.log("updated siss", updated);
    dispatch(setEvents(updated));

    // setData((prev: any) => {
    //   prev = [...updated];
    //   return prev;
    // });

    console.log("data+_+_+_", event);
  };

  const handleResetFilter = () => {
    dispatch(addScheduleFilter(emptyFilter));
    getData(currentPage, emptyFilter);
  };

  const handleAddToCart = (data: CartItem) => {
    const eventDateStr = data?.attributes?.event_register_start_date; // This is the date string
    const eventEndStr = data?.attributes?.event_register_end_date; // This is the date string
    const eventStartDate = new Date(eventDateStr)
      .setHours(0, 0, 0, 0)
      .valueOf(); // Convert the string to a Date object

    const eventEndDate = new Date(eventEndStr)
      .setHours(23, 59, 59, 999)
      .valueOf(); // Convert the string to a Date object

    // Get the current date and time in the Indian time zone
    const now = new Date().getTime();

    // // Compare the two dates
    if (eventStartDate < now && eventEndDate > now) {
      dispatch(addItem({ data, persist: false }));
      return true;
    } else {
      if (eventStartDate > now) {
        toast.error("Event registration has not started yet.", ToastOptions);
      } else {
        toast.error(
          "Sorry, the registration deadline has passed. Explore our other events!",
          ToastOptions,
        );
      }
      return false;
    }
  };

  const handleRemoveFromCart = (data: CartItem) => {
    // Dispatch the removeItem action with the item's ID
    dispatch(removeItem({ data, persist: false }));
  };

  const handleOnclick = async () => {
    // if (token) {
    //   const response = await axiosInstance.post("/auth/checkRegister", {
    //     token,
    //   });

    //   if (response?.data[0]?.register == false) {
    //     router.push(`/signup`);
    //   } else {
    //     router.push("/payment");
    //   }
    // } else {
    router.push("/cart");
    // }
  };

  useEffect(() => {
    let matchingCartItem: any;
    const updatedData: any = event.map((item: any) => {
      matchingCartItem = cart.find((val: any) => val.id === item.id);
      return {
        ...item,
        inCart: matchingCartItem ? matchingCartItem.inCart : 0,
      };
    });
    // setData(updatedData);
    dispatch(setEvents(updatedData));
    const startIndex = (currentPage - 1) * itemsPerPage;
    dispatch(
      setPaginatedEvents(
        updatedData.slice(startIndex, startIndex + itemsPerPage),
      ),
    );
  }, [cart]);

  useEffect(() => {
    // const qp: any = urlParams.get("a");
    // if (qp !== "false") {
    // dispatch(addFilter(filters));
    getData(currentPage, filter);
    // } else {
    //   dispatch(setLoading(false));
    // }
    // getData(currentPage, filter);
    // setToken(localStorage.getItem("token"));
  }, [currentPage]);

  return (
    <div
      className="property-listing-six bg-pink-two md-pt-80 "
      style={{ backgroundColor: "#F5F5FF" }}
    >
      {loading && <Loader />}
      <div className="container container-large">
        <div className="row events-container">
          <div className="col-lg-8">
            <div className="ps-xxl-3">
              <div className="listing-header-filter d-sm-flex justify-content-between align-items-center mb-40 lg-mb-30">
                <div>
                  Showing{" "}
                  <span className="color-dark fw-500">
                    {event?.length > 0
                      ? (filter.currentPage - 1) * itemsPerPage + 1
                      : 0}
                  </span>
                  {event?.length > 0 && (
                    <>
                      <span>-</span>
                      <span className="color-dark fw-500">
                        {event?.length > 0
                          ? Math.min(filter.currentPage * itemsPerPage, count)
                          : 0}
                      </span>
                    </>
                  )}{" "}
                  of <span className="color-dark fw-500">{count}</span> Results
                </div>
              </div>
              {event?.length > 0 ? (
                <div className="row gx-xxl-5 mx-1 mx-md-0">
                  {/* {event} */}
                  {event?.map((item: any, index: number) => (
                    <EventCard item={item} key={index} />
                  ))}
                </div>
              ) : (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    height: "60vh",
                    fontSize: "1.25rem",
                    fontWeight: 500,
                  }}
                >
                  No events found.
                </div>
              )}
              {/* <ReactPaginate
                breakLabel="..."
                nextLabel={<Image src={icon} alt="" className="ms-2" />}
                onPageChange={async (e) => {
                  console.log("selected page", e);
                  const newFilter = await new Promise((resolve) => {
                    const prevFilter = { ...filter };
                    const newFilter = {
                      ...prevFilter,
                      currentPage: e.selected + 1,
                    };
                    dispatch(addFilter(newFilter));
                    resolve(newFilter);
                    return newFilter;
                  });
                  setTimeout(() => {}, 5000);
                  // setcurrentPage(e.selected + 1);
                  await getData(e.selected + 1, newFilter);
                }}
                // we need to substract it accepts index
                forcePage={filter.currentPage - 1}
                pageRangeDisplayed={1}
                pageCount={Math.ceil(count / 8)}
                previousLabel={<Image src={icon} alt="" className="ms-2" />}
                renderOnZeroPageCount={null}
                className="pagination-one d-flex align-items-center justify-content-center justify-content-sm-start style-none py-4"
              /> */}

              <div
                className="my-4"
                style={{
                  display: "flex",
                  alignItems: "stretch",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div className="text-sm text-black-1500">
                  Showing {startItem} to {endItem} of {count}
                </div>
                <div>
                  <Pagination
                    count={Math.ceil(count / itemsPerPage)}
                    page={currentPage}
                    onChange={onPageChange}
                    shape="rounded"
                    color="primary"
                    sx={{
                      "& .MuiPaginationItem-root.Mui-selected": {
                        backgroundColor: "rgb(63, 65, 209)",
                        color: "#fff",
                      },
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-lg-4 order-lg-first"
            style={{
              marginBottom: "2rem",
            }}
          >
            <div className="advance-search-panel">
              <div className="main-bg">
                <DropdownOne
                  setcurrentPage={setcurrentPage}
                  handleResetFilter={handleResetFilter}
                  getData={getData}
                  currentPage={currentPage}
                  filter={filter}
                  addFilter={addScheduleFilter}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleListing;
